import React from 'react';
import { useTabs, TabBar } from './TabManager';
import { useVbMenu, tabButtonOn } from '../utils/vbPerms';
import BudgetCredit   from './Budget/BudgetCredit';    // منابع اعتباری
import BudgetPlan     from './Budget/BudgetPlan';      // طرح‌ها
import BudgetProgram  from './Budget/BudgetProgram';   // برنامه‌ها
import BudgetProject  from './Budget/BudgetProject';   // پروژه‌ها
import BudgetActivity from './Budget/BudgetActivity';  // فعالیت‌ها
import BudgetTransaction    from './Budget/BudgetTransaction';    // تایید اعتبار و تخصیص و ثبت دریافتی
import BudgetTamalokHavaleh from './Budget/BudgetTamalokHavaleh'; // تامین اعتبار حواله‌ها و ثبت تنخواه
import BudgetProgramShomool from './Budget/BudgetProgramShomool'; // ثبت اعتبار خارج از شمول

/*
  تب «اعتبارات»
  فرم‌ها همان فرم‌های بودجه‌اند ولی با حالت «اعتبارات» باز می‌شوند:
    ثبت اعتبار → فقط دریافتی‌ها (نقدی، تنخواه، اسناد) و ارسال به حسابداری قابل ثبت است
    حواله      → فقط حواله‌های ارسال‌شده به اعتبارات، حوالهٔ جدید = پرداخت تنخواه، اقلام فقط‌خواندنی
  هر دکمه با نام خودش در این تب کنترل می‌شود (مستقل از دکمه‌های تب بودجه).
*/
const CREDIT_BUTTONS = [
  /* ── ستون تعاریف (سمت راست) ── */
  { key: 'credit_source', vb: 'BTNCREDIT3',         label: 'منابع اعتباری', icon: '💠', bg: 'linear-gradient(135deg,#1b5e20,#2e7d32)', page: 'credit_source' },
  { key: 'plans',         vb: 'BTNTAMALOKPROGRAM1', label: 'طرحها',         icon: '📐', bg: 'linear-gradient(135deg,#004d40,#00695c)', page: 'plans' },
  { key: 'programs',      vb: 'BTNJARIPROGRAM1',    label: 'برنامه ها',     icon: '📚', bg: 'linear-gradient(135deg,#1a237e,#283593)', page: 'programs' },
  { key: 'projects',      vb: 'BTNPROJECT3',        label: 'پروژه ها',      icon: '🗂️', bg: 'linear-gradient(135deg,#0d47a1,#1565c0)', page: 'projects' },
  { key: 'activities',    vb: 'BTNACTIVITIES1',     label: 'فعالیت ها',     icon: '📊', bg: 'linear-gradient(135deg,#006064,#00838f)', page: 'activities' },

  /* ── ستون عملیات ── */
  { key: 'hazineh_credit',  vb: 'BTNHAZINEHBUDGETTRANSACTION1', label: 'تایید اعتبار و تخصیص و ثبت دریافتی اعتبارات هزینه ای',                 icon: '💰', bg: 'linear-gradient(135deg,#e65100,#f57c00)', page: 'hazineh_credit' },
  { key: 'hazineh_havaleh', vb: 'BTNHAZINEHBUDGETHAVALEH1',     label: 'تامین اعتبار حواله های اعتبارات هزینه ای و ثبت تنخواه',               icon: '🧾', bg: 'linear-gradient(135deg,#bf360c,#d84315)', page: 'hazineh_havaleh' },
  { key: 'tamalok_credit',  vb: 'BTNTAMALOKBUDGETTRANSACTION1', label: 'تایید اعتبار و تخصیص و ثبت دریافتی اعتبارات تملک داراییهای سرمایه ای', icon: '🏛️', bg: 'linear-gradient(135deg,#4a148c,#6a1b9a)', page: 'tamalok_credit' },
  { key: 'tamalok_havaleh', vb: 'BTNTAMALOKBUDGETHAVALEH1',     label: 'تامین اعتبار حواله های اعتبارات تملک داراییهای سرمایه ای و ثبت تنخواه', icon: '📑', bg: 'linear-gradient(135deg,#311b92,#4527a0)', page: 'tamalok_havaleh' },
  { key: 'out_of_scope',    vb: 'BTNSHOMOOL',                   label: 'ثبت اعتبار خارج از شمول',                                             icon: '➕', bg: 'linear-gradient(135deg,#00695c,#00796b)', page: 'out_of_scope_credit' },
];

/* فرم‌های مشترک با حالت تب اعتبارات */
const HazinehCredit  = props => <BudgetTransaction {...props} kind={0} tab="credit" />;
const TamalokCredit  = props => <BudgetTransaction {...props} kind={1} tab="credit" />;
const HazinehHavaleh = props => <BudgetTamalokHavaleh {...props} programType={0} tab="credit" />;
const TamalokHavaleh = props => <BudgetTamalokHavaleh {...props} programType={1} tab="credit" />;

const PAGE_COMPONENTS = {
  credit_source:   BudgetCredit,
  plans:           BudgetPlan,
  programs:        BudgetProgram,
  projects:        BudgetProject,
  activities:      BudgetActivity,
  hazineh_credit:  HazinehCredit,
  hazineh_havaleh: HazinehHavaleh,
  tamalok_credit:  TamalokCredit,
  tamalok_havaleh: TamalokHavaleh,
  out_of_scope_credit: BudgetProgramShomool,
};

export default function PrepareCredit({ user, onBack }) {
  const { openTab, goHome } = useTabs();

  const openSubPage = (btn) => {
    const Comp = PAGE_COMPONENTS[btn.page];
    if (!Comp) { alert(`صفحه "${btn.label}" در حال توسعه است`); return; }
    openTab(`credit:${btn.page}`, btn.label, btn.icon,
      () => <Comp user={user} onBack={goHome} />);
  };

  // دکمه‌های تب — دکمهٔ بی‌مجوز غیرفعال (خاکستری) دیده می‌شود
  const menu = useVbMenu();
  const allowedBtns = CREDIT_BUTTONS.map(btn => ({
    ...btn, _on: tabButtonOn(menu, 'TBPREPARECREDIT', btn.vb),
  }));
  const enabledCount = allowedBtns.filter(b => b._on).length;

  const gridResponsiveCSS = `@media(max-width:640px){.arjan-acc-grid{grid-template-columns:repeat(2,1fr)!important;gap:16px!important;max-width:360px;margin:0 auto;padding:0 12px;}}`;

  return (
    <><style>{gridResponsiveCSS}</style>
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}><img src={require('../assets/images/arjan.png')} alt="ارجان" style={{width:'36px',height:'36px',borderRadius:'8px'}}/></div>
          <div><div style={s.hTitle}>سامانه ارجان</div><div style={s.hSub}>بخش اعتبارات</div></div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>
      <TabBar/>
      <main style={s.main}>
        <div style={s.hero}><div style={s.heroIcon}>🏦</div><div><h2 style={s.heroTitle}>اعتبارات</h2><p style={s.heroSub}>{enabledCount} مورد در دسترس شما</p></div></div>
        {enabledCount > 0 || allowedBtns.length > 0 ? (
          <div className="arjan-acc-grid" style={s.grid}>
            {allowedBtns.map(btn => (
              <div key={btn.key} style={s.btnWrap}>
                <button disabled={!btn._on} style={{...s.btn,background:btn.bg,...(btn._on?{}:DISABLED)}} onClick={()=>btn._on&&openSubPage(btn)}
                  onMouseEnter={e=>{if(!btn._on)return;e.currentTarget.style.transform='translateY(-8px) scale(1.05)';e.currentTarget.style.boxShadow='0 16px 40px rgba(0,0,0,0.35)';}}
                  onMouseLeave={e=>{e.currentTarget.style.transform='translateY(0) scale(1)';e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.2)';}}>
                  <span style={s.btnIcon}>{btn.icon}</span>
                </button>
                <div style={s.btnLabel}>{btn.label}</div>
              </div>
            ))}
          </div>
        ) : (<div style={s.noAccess}><div style={{fontSize:'56px',marginBottom:'16px'}}>🔒</div><div style={{fontSize:'16px',color:'#666'}}>دسترسی به این بخش تعریف نشده است</div></div>)}
      </main>
    </div></>
  );
}

/* استایل‌ها */
const s = {
  page:{minHeight:'100vh',background:'#f0f2f7',fontFamily:"'Vazirmatn',Tahoma,sans-serif",direction:'rtl'},
  header:{background:'linear-gradient(135deg,#0a1628,#1a2f50)',padding:'12px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 2px 16px rgba(0,0,0,0.3)',position:'sticky',top:0,zIndex:100},
  hLeft:{display:'flex',alignItems:'center',gap:'12px'},
  backBtn:{padding:'6px 14px',background:'rgba(255,255,255,0.12)',color:'#fff',border:'1px solid rgba(255,255,255,0.25)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  hLogo:{width:'40px',height:'40px',background:'rgba(200,168,75,0.12)',border:'1px solid rgba(200,168,75,0.3)',borderRadius:'9px',display:'flex',alignItems:'center',justifyContent:'center'},
  hTitle:{fontSize:'16px',fontWeight:'700',color:'#fff'},
  hSub:{fontSize:'11px',color:'rgba(255,255,255,0.55)'},
  userName:{fontSize:'13px',color:'rgba(255,255,255,0.85)'},
  main:{padding:'32px 24px',maxWidth:'1100px',margin:'0 auto'},
  hero:{display:'flex',alignItems:'center',gap:'16px',marginBottom:'32px'},
  heroIcon:{fontSize:'40px'},
  heroTitle:{fontSize:'22px',fontWeight:'800',color:'#1a2f50',margin:0},
  heroSub:{fontSize:'13px',color:'#888',margin:'4px 0 0'},
  grid:{display:'grid',gridTemplateColumns:'repeat(4,160px)',gap:'24px',justifyContent:'center'},
  btnWrap:{display:'flex',flexDirection:'column',alignItems:'center',gap:'10px'},
  btn:{width:'100%',aspectRatio:'1',border:'none',borderRadius:'20px',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'0 8px 24px rgba(0,0,0,0.2)',transition:'all .25s'},
  btnIcon:{fontSize:'36px'},
  btnLabel:{fontSize:'13px',fontWeight:'700',color:'#333',textAlign:'center'},
  noAccess:{textAlign:'center',padding:'60px 20px'},
};

// دکمهٔ تبِ بی‌مجوز: دیده می‌شود ولی کار نمی‌کند
const DISABLED = { filter: 'grayscale(1)', opacity: 0.45, cursor: 'not-allowed', boxShadow: 'none' };
